import script from "./Desktop.vue?vue&type=script&setup=true&lang=js"
export * from "./Desktop.vue?vue&type=script&setup=true&lang=js"

import "./Desktop.vue?vue&type=style&index=0&id=64c30e9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c30e9e"]])

export default __exports__